import { sendGTMEvent } from '@next/third-parties/google'

// GA4's User-ID rides the data layer under this key; the container's Google
// tag maps it into every hit. null clears it. The type follows the input: the
// loader's seed only accepts JSON, and only ever carries a signed-in id.
export const ga4UserIdEntry = <T extends string | null>(userId: T) => ({
  user_id: userId,
})

// Google's contract: the entry ahead of the container on a signed-in page
// load (MeasurementTags seeds it), a push at sign-in, a push of null at
// sign-out. The auth client does both pushes.
export const pushGa4UserId = (userId: string | null): void => {
  sendGTMEvent(ga4UserIdEntry(userId))
}
